import { render, staticRenderFns } from "./ModalMoveToFolder.vue?vue&type=template&id=b2a7b072&"
import script from "./ModalMoveToFolder.vue?vue&type=script&lang=ts&"
export * from "./ModalMoveToFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports